import { useState, useEffect, useRef } from 'react';
import { UseScrollSectionReturn } from '../types';

export const useScrollSection = (sections: string[] = ['home', 'about', 'technologies', 'projects', 'contact']): UseScrollSectionReturn => {
  const [activeSection, setActiveSection] = useState<string>('home');
  const [scrolled, setScrolled] = useState<boolean>(false);
  const rafRef = useRef<number>();

  useEffect(() => {
    const handleScroll = () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      rafRef.current = requestAnimationFrame(() => {
        const isScrolled = window.scrollY > 50;
        setScrolled(isScrolled);

        const headerHeight = document.querySelector('header')?.offsetHeight ?? 80;
        const scrollPosition = window.scrollY + headerHeight;

        for (let i = sections.length - 1; i >= 0; i--) {
          const section = document.getElementById(sections[i]);
          if (section) {
            if (scrollPosition >= section.offsetTop) {
              setActiveSection(sections[i]);
              break;
            }
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [sections]);

  return { activeSection, scrolled };
}; 